import Model from "./Model";
import IUser from "./interfaces/IUser";

export default class User extends Model implements IUser {
  static type = "users";

  static adminRoles: Array<{ name: string; id: string }> = [
    { name: "SuperAdmin", id: "superadmin" },
    { name: "SystemAdmin", id: "system_admin" },
    { name: "Administrator", id: "administrator" },
  ];

  static roles: Array<{ name: string; id: string }> = [...User.adminRoles];

  email!: string;
  name!: string;
  role!: UserRoles;
  isActive!: boolean;
  confirmedAt?: Date;

  static getRoleLabel(role: string): string | undefined {
    return this.roles.find((o) => o.id === role)?.name;
  }

  isOneOf(roles: string[]) {
    if (roles[0] === "anyone") {
      return true;
    }
    return roles?.includes(this.role) ?? false;
  }

  get isSystemAdmin() {
    return this.role === "system_admin";
  }

  get isSuperAdmin() {
    return this.role === "superadmin";
  }

  get isAdministrative(): boolean {
    return this.isOneOf(["superadmin", "administrator"]);
  }

  static fromData(data: any) {
    let user = new User(undefined);
  }
}

export type UserData = {
  id?: string;
  name?: string;
  email?: string;
  role?: UserRoles;
  isActive?: boolean;
};

export enum UserRoles {
  SYSTEM_ADMIN = "system_admin",
  SUPERADMIN = "superadmin",
  ADMINISTRATOR = "administrator",
  ANALYST = "analyst",
  USER = "user",
}
